var _excluded = ["classNames", "items", "hasItems", "onNavigate", "createURL", "showMore", "canToggleShowMore", "onToggleShowMore", "isShowingMore", "translations"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { cx } from "./lib/cx.js";
import { isModifierClick } from "./lib/isModifierClick.js";
import { ShowMoreButton } from "./ShowMoreButton.js";
function HierarchicalList(_ref) {
  var className = _ref.className,
    _ref$classNames = _ref.classNames,
    classNames = _ref$classNames === void 0 ? {} : _ref$classNames,
    items = _ref.items,
    createURL = _ref.createURL,
    onNavigate = _ref.onNavigate;
  if (items.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement("ul", {
    className: cx('ais-HierarchicalMenu-list', classNames.list, className)
  }, items.map(function (item) {
    return /*#__PURE__*/React.createElement("li", {
      key: item.value,
      className: cx('ais-HierarchicalMenu-item', classNames.item, item.data && item.data.length > 0 && cx('ais-HierarchicalMenu-item--parent', classNames.parentItem), item.isRefined && cx('ais-HierarchicalMenu-item--selected', classNames.selectedItem))
    }, /*#__PURE__*/React.createElement("a", {
      className: cx('ais-HierarchicalMenu-link', classNames.link, item.isRefined && cx('ais-HierarchicalMenu-link--selected', classNames.selectedItemLink)),
      href: createURL(item.value),
      onClick: function onClick(event) {
        if (isModifierClick(event)) {
          return;
        }
        event.preventDefault();
        onNavigate(item.value);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: cx('ais-HierarchicalMenu-label', classNames.label)
    }, item.label), /*#__PURE__*/React.createElement("span", {
      className: cx('ais-HierarchicalMenu-count', classNames.count)
    }, item.count)), item.data && /*#__PURE__*/React.createElement(HierarchicalList, {
      className: cx('ais-HierarchicalMenu-list--child', classNames.childList),
      classNames: classNames,
      items: item.data,
      onNavigate: onNavigate,
      createURL: createURL
    }));
  }));
}
export function HierarchicalMenu(_ref2) {
  var _ref2$classNames = _ref2.classNames,
    classNames = _ref2$classNames === void 0 ? {} : _ref2$classNames,
    items = _ref2.items,
    hasItems = _ref2.hasItems,
    onNavigate = _ref2.onNavigate,
    createURL = _ref2.createURL,
    showMore = _ref2.showMore,
    canToggleShowMore = _ref2.canToggleShowMore,
    onToggleShowMore = _ref2.onToggleShowMore,
    isShowingMore = _ref2.isShowingMore,
    translations = _ref2.translations,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: cx('ais-HierarchicalMenu', classNames.root, !hasItems && cx('ais-HierarchicalMenu--noRefinement', classNames.noRefinementRoot), props.className)
  }), /*#__PURE__*/React.createElement(HierarchicalList, {
    classNames: classNames,
    items: items,
    onNavigate: onNavigate,
    createURL: createURL
  }), showMore && /*#__PURE__*/React.createElement(ShowMoreButton, {
    className: cx('ais-HierarchicalMenu-showMore', classNames.showMore, !canToggleShowMore && cx('ais-HierarchicalMenu-showMore--disabled', classNames.disabledShowMore)),
    disabled: !canToggleShowMore,
    onClick: onToggleShowMore,
    isShowingMore: isShowingMore,
    translations: translations
  }));
}